"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixRoomService = void 0;
const MatrixRoom_1 = require("../models/MatrixRoom");
class MatrixRoomService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    async createRoom(accessToken, config = {}) {
        return this.httpClient.post('/createRoom', config, { accessToken });
    }
    async inviteToRoom(accessToken, user, room) {
        if (room.status !== MatrixRoom_1.MatrixRoomStatus.JOINED && room.status !== MatrixRoom_1.MatrixRoomStatus.UNKNOWN) {
            return Promise.reject(`User is not a member of room ${room.id}.`);
        }
        return this.httpClient.post(`/rooms/${room.id}/invite`, { user_id: user }, { accessToken });
    }
    async joinRoom(accessToken, room) {
        if (room.status === MatrixRoom_1.MatrixRoomStatus.JOINED) {
            return Promise.resolve({ room_id: room.id });
        }
        return this.httpClient.post(`/rooms/${room.id}/join`, {}, { accessToken });
    }
}
exports.MatrixRoomService = MatrixRoomService;
//# sourceMappingURL=MatrixRoomService.js.map